module.exports = new __parcel__URL__("loading_screen_rectangle.8e39544e.png").toString();